import m from 'mithril';
import modalCloseButton from '../../../components/modalCloseButton';



const modal = {
  key: 'SELECT_DEPARTMENT_CARD_MODAL',

  show() {
    $(`#${modal.key}`).modal('show');
  },
  hide() {
    $(`#${modal.key}`).modal('hide');
  },
  oninit({ state }) {
    state.loading = false;
  },
  view({ state }) {
    return m('.modal', { id: modal.key },
      [
        m('.modal-dialog.modal-dialog-centered[role="document"]',
          [
            m('.modal-content',
              [
                m('.modal-header',
                  [
                    m('h1.modal-title', { style: { fontSize: '1.5rem', fontWeight: 'bold' } }, 'Assign Vehicle'),
                    m("div", { "class": "btn btn-icon btn-sm btn-active-light-primary ms-2", "data-bs-dismiss": "modal", "aria-label": "Close" },
                      m(modalCloseButton)
                    )
                  ]),
                m('.modal-body',
                  [
                    m('form',
                      [
                        m("input", {"class":"form-control","type":"text","placeholder":"Search for a Vehicle", style: { "margin-bottom": '20px' } }),
                        Array(5).fill(0).map((card, index) => {
                          return [m("div", { "class": "form-check" },
                            [
                              m("input", {
                                "class": "form-check-input",
                                "type": "checkbox",
                                "value": "",
                                "id": "flexCheckDefault",
                                style: { marginTop: '5px' }
                              }),
                              m("div", { style: { paddingLeft: '20px' } },
                                [
                                  m("a", {
                                    "class": "text-gray-800 fw-bolder text-hover-primary fs-4",
                                    "href": "#"
                                  },
                                    "Department Vehicle"
                                  ),
                                  m("div", { style: { display: 'flex', justifyContent: 'space-between' } }, [
                                    m("div", [
                                      m("span", { style: { fontWeight: 'bold' } }, "Vehicle:"),
                                      m("span", " 12345678909876")
                                    ]),
                                    m("div", [
                                      m("span", { style: { fontWeight: 'bold' } }, "Status:"),
                                      m("span", { style: { color: '#0D9488' } }, " Active")
                                    ])
                                  ])

                                ]
                              )
                            ]
                          ),
                          index < 4 && m("div", { "class": "separator my-5" })
                          ]
                        })

                      ]),
                  ]),
                m('.modal-footer',
                  [
                    m('button.btn.btn-primary[type="button"][class="w-100"]', {
                      onclick() {
                        modal.hide();
                      },
                    }, 'Submit'),
                  ]),
              ]),
          ]),
      ]);
  },
};


export default modal;
